import "../../../css/wallet/History/HistoryLoading.css";

function HistoryLoading1({ theme }) {
  return (
    <div className={`dfdeewdfv`}>
      {Array.from({ length: 3 }).map((_, index) => {
        return (
          <div className="kjjjfkke3"> 
            <div className={`jdkkkwjcx shimmer ${theme}`}></div>
          </div>
        );
      })}
    </div>
  );
}

export default HistoryLoading1;
